import * as act from "./actiontypes";
import * as url from "../../constants/urls";
import { genderVerification } from "./onboardersActions";

export const login = ({ creds: data, keepMeSignedIn }) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    if (data[key] === "") continue;
    form_data.append(key, data[key]);
  }
  if (keepMeSignedIn) {
    form_data.append("keep", "true");
  }
  return (dispatch, getState) => {
    return fetch(url.loginUrl, {
      method: "POST",
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
        if (json.success) {
          const {
            token,
            type,
            code,
            gender,
            email,
            mobile,
            name,
            value,
            mobileverified,
          } = json;
          console.log(code);

          if (json.code === -6) {
            localStorage.setItem("token", token);
            return { code, gender, email, mobile, type, mobileverified };
          }
          if (json.code === -2) {
            localStorage.setItem("token", token);
            dispatch({ type: act.REGISTER_SUCCESS, token });
            return { code, token, name, value, type };
          }
          localStorage.setItem("token", token);
          localStorage.setItem("utoken", token);
          localStorage.setItem("utype", type);
          document.cookie = `token=${token}; path=/; domain=.devsaycheese.com;`;
          document.cookie = `user_type=${type}; path=/; domain=.devsaycheese.com;`;
          dispatch({ type: act.LOGIN_SUCCESS, user: { token, type } });
          return { type };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const updateCred = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const token = localStorage.getItem("token");
    return fetch(url.updateCredUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const forgotPassword = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    return fetch(url.forgotPasswordUrl, {
      method: "POST",
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({ type: act.FORGOT_PASSWORD, token: json.token });
          return true;
          // return json.;
        } else {
          // dispatch({ type: REGISTER_FAILURE, message: json.message });
          throw Error(json.message);
        }
      });
  };
};

export const resendOtp = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().onboard.onboarder;
    return fetch(url.resendOtpUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const verifyForgotPassword = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user.forgotpassword;
    return fetch(url.verifyForgotPasswordUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const resetPassword = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user.forgotpassword;
    return fetch(url.resetPasswordUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({ type: act.PASSWORD_RESET_SUCCESS });
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const updatePassword = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.updatePasswordUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const checkAvailability = (data) => {
  // converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.checkAvailabilityUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        return json.msg === "Available";
      });
  };
};
export const logout = () => {
  //clear my data
  document.cookie =
    "token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.devsaycheese.com;";
  document.cookie =
    "user_type=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.devsaycheese.com;";
  return (dispatch, getState) => {
    localStorage.removeItem("utoken");
    localStorage.removeItem("token");
    localStorage.removeItem("utype");
    window.location.href = "/";
    dispatch({ type: act.CLEAR_MY_DATA });
  };
};

export const googleAuthSuccess = (data) => {
  return async (dispatch) => {
    var form_data = new FormData();
    for (let key in data) {
      form_data.append(key, data[key]);
    }
    dispatch({ type: act.CLEAR_MY_DATA });

    const response = await fetch(url.googleAuthUrl, {
      method: "POST",
      body: form_data,
    });
    const resData = await response.json();
    let {
      name,
      email,
      firstname,
      lastname,
      age,
      gender,
      mobile,
      countrycode,
    } = data;
    const { token } = resData;
    localStorage.setItem("token", token);
    dispatch({ type: act.GOOGLE_SIGN_UP, payload: { token } });
    dispatch({
      type: act.SET_ONBOARDER,
      payload: ["fromState", true],
    });
    if (resData.code === 1) {
      const { token, type } = resData;
      dispatch({ type: act.LOGIN_SUCCESS, user: { token, type } });
      localStorage.setItem("utoken", token);
      localStorage.setItem("utype", type);
      document.cookie = `token=${token}; path=/; domain=.devsaycheese.com;`;
      document.cookie = `user_type=${type}; path=/; domain=.devsaycheese.com;`;
      return { token, type, action: "login" };
    }
    if (resData.code === -4 && gender) {
      await dispatch(genderVerification({ gender: gender }));
    }
    if (resData.code === -5 && gender) {
      await dispatch(genderVerification({ gender: gender }));
    }
    if (resData.msg === "Email Already Registered") {
      throw new Error(resData.msg);
    }
    age = age || "";
    gender = gender || "";
    mobile = mobile || "";
    if (resData.code === -6) {
      const { gender: genderResData } = resData;
      dispatch({
        type: act.GOOGLE_SIGN_UP,
        payload: {
          gsign: true,
          name: name,
          email: email,
          token: token,
          firstname: firstname,
          lastname: lastname,
          gender: genderResData,
          age: age,
          mobile: mobile,
          countrycode,
        },
      });
      if (gender === "Female") {
        dispatch({
          type: act.SET_ONBOARDER,
          payload: ["coins", 25],
        });
      }
      return { action: "profile" };
    } else {
      dispatch({
        type: act.GOOGLE_SIGN_UP,
        payload: {
          gsign: true,
          name: name,
          email: email,
          token: token,
          firstname: firstname,
          lastname: lastname,
          age: age,
          gender: gender,
          mobile: mobile,
          countrycode,
        },
      });

      return false;
    }
  };
};

export const facebookAuthSuccess = (data) => async (dispatch) => {
  console.log(data);
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  dispatch({ type: act.CLEAR_MY_DATA });

  const response = await fetch(url.facebookAuthUrl, {
    method: "POST",
    body: form_data,
  });
  const resData = await response.json();
  let {
    name,
    email,
    firstname,
    lastname,
    age,
    gender,
    mobile,
    countrycode,
  } = data;
  const { token } = resData;
  localStorage.setItem("token", token);
  dispatch({ type: act.FACEBOOK_SIGN_UP, payload: { token } });
  dispatch({
    type: act.SET_ONBOARDER,
    payload: ["fromState", true],
  });
  if (resData.code === 1) {
    const { token, type } = resData;
    dispatch({ type: act.LOGIN_SUCCESS, user: { token, type } });
    localStorage.setItem("utoken", token);
    localStorage.setItem("utype", type);
    document.cookie = `token=${token}; path=/; domain=.devsaycheese.com;`;
    document.cookie = `user_type=${type}; path=/; domain=.devsaycheese.com;`;
    return { token, type, action: "login" };
  }
  if (resData.code === -4 && gender) {
    await dispatch(genderVerification({ gender: gender }));
  }
  if (resData.code === -5 && gender) {
    await dispatch(genderVerification({ gender: gender }));
  }
  if (resData.msg === "Email Already Registered") {
    throw new Error(resData.msg);
  }
  age = age || "";
  gender = gender || "";
  mobile = mobile || "";
  console.log(gender, age, mobile);
  if (resData.code === -6) {
    const { gender: genderResData } = resData;
    dispatch({
      type: act.FACEBOOK_SIGN_UP,
      payload: {
        fbsign: true,
        name: name,
        email: email,
        token: token,
        firstname: firstname,
        lastname: lastname,
        gender: genderResData,
        age: age,
        mobile: mobile,
        countrycode,
      },
    });
    if (gender === "Female") {
      dispatch({
        type: act.SET_ONBOARDER,
        payload: ["coins", 25],
      });
    }

    return { action: "profile" };
  } else {
    dispatch({
      type: act.FACEBOOK_SIGN_UP,
      payload: {
        fbsign: true,
        name: name,
        email: email,
        token: token,
        firstname: firstname,
        lastname: lastname,
        age: age,
        gender: gender,
        mobile: mobile,
        countrycode,
      },
    });

    return false;
  }
};
